import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from 'lodash-es';
export default {
  name: 'SortTree',
  props: {
    props: Object
  },
  data: function data() {
    return {
      sortTreeData: []
    };
  },
  methods: {
    /**
     * 更新每一项的排序值
     */
    updateItemSortValue: function updateItemSortValue() {
      var vm = this;
      function loop(source) {
        source.forEach(function (item, index) {
          item[vm.props.sort] = index;
          item[vm.props.seleted] = 1;
          if (item[vm.props.children]) {
            loop(item[vm.props.children]);
          }
        });
      }
      loop(this.sortTreeData);
    },
    /**
     * 获取sortTreeData
     */
    getData: function getData() {
      this.updateItemSortValue();
      return this.sortTreeData;
    },
    /**
     * 设置sortTreeData
     */
    setData: function setData(data) {
      this.sortTreeData = data;
    },
    /**
     * 拖拽事件
     */
    handleDragstart: function handleDragstart(event, moveItem, moveIndex, isRoot) {
      event.dataTransfer.setData('Text', JSON.stringify({
        isRoot: isRoot,
        moveItem: moveItem,
        moveIndex: moveIndex
      }));
    },
    /**
     * 放置事件
     */
    handleDrop: function handleDrop(event, dropItem, dropIndex, parentIndex, parentItem) {
      var _this = this;
      var _JSON$parse = JSON.parse(event.dataTransfer.getData('Text')),
        isRoot = _JSON$parse.isRoot,
        moveItem = _JSON$parse.moveItem,
        moveIndex = _JSON$parse.moveIndex;
      if (isRoot) {
        if (parentItem) {
          dropItem = parentItem;
        }
        if (parentIndex !== undefined) {
          dropIndex = parentIndex;
        }
        if (moveItem.id === dropItem.id) return;
        // insert
        this.sortTreeData.splice(dropIndex + (moveIndex < dropIndex ? 1 : 0), 0, moveItem);
        // delete
        this.sortTreeData.splice(moveIndex + (moveIndex < dropIndex ? 0 : 1), 1);
      } else {
        if (moveItem.pid !== dropItem.pid) return;
        if (moveItem.id === dropItem.id) return;
        // insert
        parentItem[this.props.children].splice(dropIndex + (moveIndex < dropIndex ? 1 : 0), 0, moveItem);
        // delete
        parentItem[this.props.children].splice(moveIndex + (moveIndex < dropIndex ? 0 : 1), 1);
        var type = moveIndex < dropIndex ? 'next' : 'prev';
        var cloneParentItem = cloneDeep(parentItem);
        var children = cloneParentItem[this.props.children];
        children.forEach(function (item, index) {
          item[_this.props.sort] = index;
        });
        this.$emit('drop', cloneParentItem, type);
      }
    },
    /**
     * 删除事件
     */
    handleDelete: function handleDelete(item, index, parentItem, parentIndex) {
      if (parentItem) {
        var children = parentItem[this.props.children];
        children.splice(index, 1);
        if (children.length === 0) {
          this.sortTreeData.splice(parentIndex, 1);
        }
      } else {
        this.sortTreeData.splice(index, 1);
      }
      this.$emit('delete', item, this.sortTreeData.length === 0);
    }
  }
};